import * as React from 'react';

const SvgEmptyNotification = (props) => (
  <svg
    width={166}
    height={155}
    viewBox="0 0 166 155"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M88.217 125.151C120.778 125.151 147.176 98.7531 147.176 66.0755C147.176 33.3979 120.662 7 88.217 7C55.6557 7 29.2578 33.3979 29.2578 66.0755C29.2578 98.7531 55.6557 125.151 88.217 125.151Z"
      fill="#EAEEF9"
    />
    <path
      d="M154.661 47.3581C157.294 47.3581 159.429 45.2234 159.429 42.5902C159.429 39.9569 157.294 37.8223 154.661 37.8223C152.028 37.8223 149.893 39.9569 149.893 42.5902C149.893 45.2234 152.028 47.3581 154.661 47.3581Z"
      fill="#EAEEF9"
    />
    <path
      d="M161.638 28.7518C163.437 28.7518 164.895 27.2939 164.895 25.4956C164.895 23.6973 163.437 22.2395 161.638 22.2395C159.84 22.2395 158.382 23.6973 158.382 25.4956C158.382 27.2939 159.84 28.7518 161.638 28.7518Z"
      fill="#EAEEF9"
    />
    <path
      d="M31.9329 27.3506C33.7312 27.3506 35.189 25.8928 35.189 24.0945C35.189 22.2962 33.7312 20.8384 31.9329 20.8384C30.1346 20.8384 28.6768 22.2962 28.6768 24.0945C28.6768 25.8928 30.1346 27.3506 31.9329 27.3506Z"
      fill="#EAEEF9"
    />
    <path
      d="M12.0471 90.1477C15.3868 90.1477 18.0942 87.4403 18.0942 84.1006C18.0942 80.7608 15.3868 78.0535 12.0471 78.0535C8.70738 78.0535 6 80.7608 6 84.1006C6 87.4403 8.70738 90.1477 12.0471 90.1477Z"
      fill="#EAEEF9"
    />
    <g filter="url(#filter0_d_175_13579)">
      <path
        d="M136.215 121.858H37.5791C35.6577 121.858 34.0811 120.281 34.0811 118.36V94.2674C34.0811 92.3459 35.6577 90.7693 37.5791 90.7693H136.215C138.137 90.7693 139.713 92.3459 139.713 94.2674V118.36C139.713 120.281 138.137 121.858 136.215 121.858Z"
        fill="url(#paint0_linear_175_13579)"
      />
    </g>
    <path
      d="M119.858 102.446H64.9232C63.7408 102.446 62.8047 101.728 62.8047 100.82C62.8047 99.9126 63.7408 99.1942 64.9232 99.1942H119.858C121.04 99.1942 121.977 99.9126 121.977 100.82C121.977 101.728 121.04 102.446 119.858 102.446Z"
      fill="#D6DCE8"
    />
    <path
      d="M100.15 112.349H64.9232C63.7408 112.349 62.8047 111.631 62.8047 110.723C62.8047 109.816 63.7408 109.097 64.9232 109.097H100.15C101.333 109.097 102.269 109.816 102.269 110.723C102.269 111.631 101.333 112.349 100.15 112.349Z"
      fill="#D6DCE8"
    />
    <path
      d="M48.6649 115.059C53.5083 115.059 57.4347 111.132 57.4347 106.289C57.4347 101.445 53.5083 97.519 48.6649 97.519C43.8214 97.519 39.895 101.445 39.895 106.289C39.895 111.132 43.8214 115.059 48.6649 115.059Z"
      fill="#989FB0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.1281 104.289L46.61 109.758L45.2021 108.338L50.7203 102.869L52.1281 104.289Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M46.61 102.869L52.1281 108.338L50.7203 109.758L45.2021 104.289L46.61 102.869Z"
      fill="white"
    />
    <g filter="url(#filter1_d_175_13579)">
      <path
        d="M139.53 42.5091H40.8936C38.9721 42.5091 37.3955 40.9325 37.3955 39.011V14.9185C37.3955 12.997 38.9721 11.4204 40.8936 11.4204H139.53C141.451 11.4204 143.028 12.997 143.028 14.9185V39.011C143.028 40.9325 141.451 42.5091 139.53 42.5091Z"
        fill="url(#paint1_linear_175_13579)"
      />
    </g>
    <path
      d="M123.172 23.097H68.2377C67.0552 23.097 66.1191 22.3785 66.1191 21.4711C66.1191 20.5636 67.0552 19.8452 68.2377 19.8452H123.172C124.355 19.8452 125.291 20.5636 125.291 21.4711C125.291 22.3785 124.355 23.097 123.172 23.097Z"
      fill="#D6DCE8"
    />
    <path
      d="M103.465 33H68.2377C67.0552 33 66.1191 32.2816 66.1191 31.3742C66.1191 30.4667 67.0552 29.7483 68.2377 29.7483H103.465C104.647 29.7483 105.583 30.4667 105.583 31.3742C105.583 32.2816 104.647 33 103.465 33Z"
      fill="#D6DCE8"
    />
    <path
      d="M51.9788 35.7099C56.8223 35.7099 60.7487 31.7835 60.7487 26.94C60.7487 22.0966 56.8223 18.1702 51.9788 18.1702C47.1354 18.1702 43.209 22.0966 43.209 26.94C43.209 31.7835 47.1354 35.7099 51.9788 35.7099Z"
      fill="#989FB0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M55.4421 24.9406L49.924 30.4094L48.5161 28.9889L54.0342 23.52L55.4421 24.9406Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M49.924 23.52L55.4421 28.9889L54.0342 30.4094L48.5161 24.9406L49.924 23.52Z"
      fill="white"
    />
    <g filter="url(#filter2_d_175_13579)">
      <path
        d="M124.391 81.9971H25.7056C23.7841 81.9971 22.2075 80.4205 22.2075 78.499V54.4065C22.2075 52.4851 23.7841 50.9084 25.7056 50.9084H124.342C126.263 50.9084 127.84 52.4851 127.84 54.4065V78.499C127.889 80.4698 126.313 81.9971 124.391 81.9971Z"
        fill="url(#paint2_linear_175_13579)"
      />
    </g>
    <path
      d="M36.8407 75.2474C41.6841 75.2474 45.6105 71.321 45.6105 66.4775C45.6105 61.634 41.6841 57.7076 36.8407 57.7076C31.9972 57.7076 28.0708 61.634 28.0708 66.4775C28.0708 71.321 31.9972 75.2474 36.8407 75.2474Z"
      fill="#989FB0"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M41.686 64.4254L35.4608 70.6507L31.9946 67.1845L33.4088 65.7703L35.4608 67.8222L40.2718 63.0112L41.686 64.4254Z"
      fill="white"
    />
    <path
      d="M108.034 62.5852H53.099C51.9166 62.5852 50.9805 61.8668 50.9805 60.9594C50.9805 60.0519 51.9166 59.3335 53.099 59.3335H108.034C109.216 59.3335 110.152 60.0519 110.152 60.9594C110.152 61.8668 109.167 62.5852 108.034 62.5852Z"
      fill="#D6DCE8"
    />
    <path
      d="M88.3263 72.5375H53.099C51.9166 72.5375 50.9805 71.8191 50.9805 70.9116C50.9805 70.0042 51.9166 69.2858 53.099 69.2858H88.3263C89.5087 69.2858 90.4448 70.0042 90.4448 70.9116C90.3956 71.8191 89.4594 72.5375 88.3263 72.5375Z"
      fill="#D6DCE8"
    />
    <defs>
      <filter
        id="filter0_d_175_13579"
        x={12.0811}
        y={79.7693}
        width={149.632}
        height={75.0887}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_175_13579"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_175_13579"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_175_13579"
        x={15.3955}
        y={0.420395}
        width={149.633}
        height={75.0887}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_175_13579"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_175_13579"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_175_13579"
        x={0.207489}
        y={39.9084}
        width={149.634}
        height={75.0887}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={11} />
        <feGaussianBlur stdDeviation={11} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_175_13579"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_175_13579"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_175_13579"
        x1={86.8628}
        y1={90.0502}
        x2={86.8628}
        y2={122.193}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_175_13579"
        x1={90.1773}
        y1={10.7013}
        x2={90.1773}
        y2={42.8442}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_175_13579"
        x1={74.9899}
        y1={50.1893}
        x2={74.9899}
        y2={82.3323}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#FDFEFF" />
        <stop offset={0.9964} stopColor="#ECF0F5" />
      </linearGradient>
    </defs>
  </svg>
);

export default SvgEmptyNotification;
